/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path logout
 * @description Logout page
 */
import React from "react";
const Logout = () => {
  return (
    <>
      <h1 data-testid="logout-placeholder">Placeholder for user logout page</h1>
    </>
  );
};
export default Logout;
